import styled from 'styled-components';

export const ListItemRightActionsSC = styled.div`
  min-width: 56px;
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 8px;
`;
